import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { ErrorMessage, IsLoading } from '../../components/LoadingOrErrorCollection'
import { shouldRender } from '../../utils'
import { Collection } from '../Collection'
import Frame from '../Frame'
import { CollectionItem } from './theme'
import { Photo } from "../CollectionProductsSets/theme";
import { InfoBox, InfoText } from "../Frame/theme";

const CollectionProducts = ({ isLoading, errMessage, photos = [], insert }) => (
  <Fragment>
    <IsLoading isLoading={isLoading} />
    <ErrorMessage errMessage={errMessage} />

    {shouldRender(errMessage, isLoading) && (
      <Collection>
        {photos.map((photo, index) => (
          <CollectionItem
            key={`${index}-${photo.width}x${photo.height}`}
            onClick={() => insert(photo.width, photo.height)}
          >
            <Photo className={'loading-img'} src={`frames/${photo.width}x${photo.height}.jpg`} alt={photo.alt} />
            <InfoBox>
              <InfoText>{`Ramka ${photo.width}cm x ${photo.height}cm`}</InfoText>
            </InfoBox>
          </CollectionItem>
        ))}
      </Collection>
    )}
  </Fragment>
)

CollectionProducts.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  errMessage: PropTypes.string.isRequired,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
}

export default CollectionProducts



// WEBPACK FOOTER //
// ./src/components/CollectionProducts/index.js